module.exports = __webpack_public_path__ + "media/images/recruitment/landing/price02-8f743a3d144b5d193f613ac500a3cad0.svg";